export default "__VITE_ASSET__9e6418c1__"